import { intlPolyfill } from './intlPolyfill'
import { localizeDayJs } from './localizeDayJs'
import { localizeFlatpickr } from './localizeFlatpickr'

export const localize = async (locale: string) => {
  await Promise.allSettled([
    await localizeDayJs(locale),
    await localizeFlatpickr(locale),
  ])

  if (typeof window !== 'undefined') {
    // Client side logic

    /**
     * Load required polyfills.
     */
    try {
      await intlPolyfill(locale)
    } catch (e) {
      logger.error('Unable to initialize polyfills', e)
    }
  }
}
